//#region src/logic/phoneAuthFailure.ts
var e = {
	invalid_code: "invalid_code",
	expired: "expired",
	max_attempts: "max_attempts",
	already_verified: "already_verified",
	rate_limited: "rate_limited",
	turnstile_required: "generic",
	POW_STALE: "pow_stale",
	PHONE_SIGN_IN_UNAVAILABLE: "unavailable",
	PROVIDER_UNAVAILABLE: "unavailable",
	INVALID_PHONE: "invalid_phone",
	PHONE_ALREADY_REGISTERED: "phone_already_registered",
	PHONE_REQUIRED: "phone_required",
	OTP_EXPIRED: "expired",
	OTP_CONSUMED: "already_verified",
	PASSKEYS_UNAVAILABLE: "passkeys_unavailable",
	PASSKEY_AUTH_FAILED: "passkey_failed",
	PASSKEY_ENROLL_FAILED: "passkey_failed",
	PASSKEY_PROOF_REUSED: "passkey_failed",
	ATTEMPT_EXPIRED: "attempt_expired",
	NO_PASSKEY: "no_passkey"
}, t = new Set([
	"expired",
	"max_attempts",
	"already_verified",
	"OTP_EXPIRED",
	"OTP_CONSUMED",
	"POW_STALE"
]), n = (e, t, n) => {
	let r = typeof t == "number" && Number.isFinite(t) ? t : typeof e == "string" ? (Date.parse(e) - n) / 1e3 : NaN;
	return !Number.isFinite(r) || r <= 0 ? null : Math.ceil(r / 60);
}, r = (e, t = Date.now()) => {
	let r = e?.response, i = r?.data ?? {};
	return {
		code: typeof i.code == "string" ? i.code : null,
		status: typeof r?.status == "number" ? r.status : null,
		minutes: n(i.retry_after, i.cooldown_seconds, t),
		message: typeof i.message == "string" ? i.message : null
	};
}, i = (t) => {
	let n = t.code ? e[t.code] ?? "generic" : "generic";
	return n === "rate_limited" && t.minutes === null ? {
		key: "auth:phoneAuthError.rate_limited_soon",
		minutes: null
	} : {
		key: `auth:phoneAuthError.${n}`,
		minutes: t.minutes
	};
}, a = (e) => e.code !== null && t.has(e.code);
//#endregion
export { a as needsNewCode, i as phoneAuthFailureCopy, r as readPhoneAuthFailure };
